import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-observerlist',
  templateUrl: './observerlist.component.html',
  styleUrls: ['./observerlist.component.scss']
})
export class ObserverlistComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
